import api from "./index"

export async function getServices({
  offset = 0,
  limit = 10,
  search = "",
} = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      offset,
      limit,
      search,
    },
  }
  return api.get("/v1/services", config)
}

export async function createService(data) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.post("/v1/services", data, config)
}

export async function updateService(id, data) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.put(`/v1/services/${id}`, data, config)
}

export async function deleteService(id) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.delete(`/v1/services/${id}`, config)
}

export async function searchServices({
  offset = 0,
  limit = 10,
  search = "",
} = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      offset,
      limit,
      search,
    },
  }
  return api.get("/v1/services", config)
}

export async function getServiceById(id) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.get(`/v1/services/${id}`, config)
}

export async function addServiceMedia(serviceId, data) {
  if (!serviceId) {
    throw new Error("Service ID is required")
  }

  const formData = new FormData()

  // Add required fields
  formData.append("title", data.title)
  formData.append("description", data.description)
  formData.append("source", data.source)

  // Add optional fields if they exist
  if (data.file_link) {
    formData.append("file_link", data.file_link)
  }

  if (!data.file_link && data.media_file) {
    formData.append("media_file", data.media_file)
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }

  return api.post(`/v1/services/${serviceId}/media`, formData, config)
}
